import { PhotoSquareOutlineIcon } from '@carboncopyco/icons';
import { TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export const LoadingFrame = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // fake progress
    const interval = setInterval(() => {
      const newProgress = progress + 25;
      if (newProgress === 125) {
        return;
      }
      setProgress(newProgress);
    }, 1000);

    return () => clearInterval(interval);
  }, [progress]);

  return (
    <AnimatePresence>
      <motion.div
        key="main"
        className={classNames(
          'w-full border border-ds-primary-300 rounded-md py-5 px-4 shadow-ds-sm relative'
        )}
      >
        <div className="flex justify-between items-center">
          <div
            className={classNames(
              'text-xs text-ds-primary-300 flex items-center gap-1'
            )}
          >
            <PhotoSquareOutlineIcon size={12} />
            <TextBase
              label="Frame"
              color="text-ds-primary-300"
            />
          </div>
        </div>
        <TextBase
          label="Loading"
          color="text-ds-natural-600"
        />
        <div
          className="absolute h-0.5 w-full bottom-0 left-0 bg-ds-natural-150"
          style={{
            height: '2px',
          }}
        >
          <div
            className="bg-ds-primary-300"
            style={{
              height: '2px',
              width: `${progress || 0}%`,
            }}
          />
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
